// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://itgfrapapp800.prod.altengroup.dir:2501';
export const API_BASE_URL = window.location.origin;

export const DEFAULT_SUGGESTIONS = [
  {
    icon: "FileText",
    iconColor: "text-blue-500",
    title: "Couverture MERCER",
    displayPrompt: "Complémentaire vs surcomplémentaire",
    prompt: "Peux-tu expliquer clairement la différence entre la complémentaire et la surcomplémentaire MERCER, et rappeler comment fonctionne le tiers payant pour les salariés ALTEN ?",
  },
  {
    icon: "GitCompareArrows",
    iconColor: "text-green-500",
    title: "Affiliation famille",
    displayPrompt: "Ajouter conjoint/enfants",
    prompt: "Dans quels cas et à quels moments puis-je affilier mon conjoint ou mes enfants à la mutuelle MERCER, quels documents fournir et comment sont prises en charge les cotisations ?",
  },
  {
    icon: "DatabaseZap",
    iconColor: "text-purple-500",
    title: "Affiliation de mon conjoint",
    displayPrompt: "Affilier de mon conjoint",
    prompt: "Quand affilier mon conjoint ou mon concubin à la mutuelle d’entreprise ?",
  },
  {
    icon: "FileText",
    iconColor: "text-blue-500",
    title: "Affiliation automatique",
    displayPrompt: "Affiliation après embauche",
    prompt: "Quand suis-je affilié automatiquement à Mercer après l’embauche ?",
  },
  {
    icon: "GitCompareArrows",
    iconColor: "text-green-500",
    title: "Affiliation enfant",
    displayPrompt: "Documents et âge",
    prompt: "Documents pour affilier un enfant et jusqu’à quel âge est-il couvert ?",
  },
  {
    icon: "DatabaseZap",
    iconColor: "text-purple-500",
    title: "Capital prévoyance",
    displayPrompt: "Bénéficiaires par défaut",
    prompt: "Bénéficiaires par défaut du capital prévoyance et comment les changer ?",
  },
];
